import {
  OrderStates,
  useClient,
  useDictionary,
  useOrder,
} from "@adamlip/okeoke.client";
import { PayAPI } from "apis/PayApi";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";

function VivaPay() {
  const { id } = useParams();
  const { getValue } = useDictionary();
  const { languageCode } = useClient();

  const [orderUUID, setOrderUUID] = useState(null);
  const { paymentState, orderState } = useOrder(null, orderUUID);
  const [paymentAgentID, setPaymentAgentID] = useState(null);
  const [link, setLink] = useState(null);
  const [error, setError] = useState(null);
  const [paySuccess, setPaySuccess] = useState("loading");
  const [countDown, setCountDown] = useState(null);
  const [buttonState, setButtonState] = useState("loading");
  const [errorCode, setErrorCode] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(() => {
    if (countDown != null) {
      timer.current = setTimeout(() => {
        setError(true);
        setCountDown(null);
      }, 1000);
    }
  }, [countDown]);

  useEffect(() => {
    if (id != null) {
      let params = id.split("-");
      setOrderUUID(params[0]);
      setPaymentAgentID(params[1]);
    }
  }, [id]);

  useEffect(() => {
    if (paySuccess && link != null) {
      setButtonState("navigateToViva");
      window.location.href = link;
    }
  }, [link, paySuccess]);

  useEffect(() => {
    if (error) setButtonState("error");
  }, [error]);

  useEffect(() => {
    if (
      orderUUID != null &&
      paymentAgentID != null &&
      typeof languageCode === "string"
    )
      start();
    // eslint-disable-next-line
  }, [languageCode, orderUUID, paymentAgentID]);

  const handleTryAgain = () => {
    setError(null);
    start();
  };

  const start = () => {
    setButtonState("loading");
    setPaySuccess("loading");

    if (paymentState?.paymentUrl != null) {
      window.location.href = paymentState?.paymentUrl;
    } else {
      let data = {
        orderUUID: orderUUID,
        languageCode: languageCode,
        paymentAgentID: paymentAgentID,
        backRef: window.location.origin + "/brandApp/vivapaybackref",
      };

      PayAPI.startOkePay(data)
        .then((response) => {
          console.log("OkePay response:", response.data);
          if (response.data.success) {
            console.log(response.data);
            setPaySuccess(true);
            setLink(
              `${response.data.data.paymentUrl}&color=${"#404040".replace(
                "#",
                ""
              )}`
            );
            //setPrice(response.data.data.total)
            //setTransactionId(response.data.data.transactionId)
          } else {
            setPaySuccess(false);
            setCountDown(true);
            setErrorCode(response.data.code);
          }
        })
        .catch((e) => {
          console.error(e);
          setCountDown(true);
        });
    }
  };

  if (
    orderState === OrderStates.BASKET ||
    orderState === OrderStates.UNCONFIRMED
  ) {
    return (
      <div className="viva-pay-root">
        {errorCode == null && buttonState === "loading" && (
          <BeatLoader color={"grey"} />
        )}
        {errorCode != null && (
          <div className="error-msg">
            {getValue(`app_v2_okePay_error_${errorCode}`)}
          </div>
        )}
        {buttonState === "error" && (
          <div
            className="btn primary hidden-content appear"
            onClick={handleTryAgain}
          >
            {getValue("app_v2_simple_tryAgain")}
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="viva-pay-root">
        <div className="error-msg">{getValue(`app_v2_orderNotPayable`)}</div>
      </div>
    );
  }
}

export default VivaPay;
